// eslint-disable-next-line import/no-restricted-paths
import { IReviewWebSchema } from '../../../node/repositories/newbuilding-card/entities/reviews/ReviewWebSchema';
import { IApplicationState } from '../../types/redux';

export const getReviewById = (id: string) => (state: IApplicationState) => {
  const reviews = state.newbuilding.reviews?.reviews;

  const review = reviews?.find(item => item.id === id) || null;

  return review as IReviewWebSchema;
};
